<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-storm`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.556 16.122C34.8 8.602 28.055 3 20 3 10.611 3 3 10.611 3 20c0 6.497 3.644 12.142 9 15.004v-4.756C8.956 27.868 7 24.163 7 20c0-7.18 5.82-13 13-13s13 5.82 13 13h2l.225.004A6 6 0 0138 31.197v4.345c4.058-1.275 7-5.065 7-9.542 0-4.994-3.66-9.133-8.444-9.878zM20 27l1.732 1a1 1 0 01.366 1.366l-1.993 3.449 2.55 1.451.01-.016 2.598 1.5a1 1 0 01.366 1.366l-4 6.928a1 1 0 01-1.366.366l-1.732-1a1 1 0 01-.366-1.366l2.49-4.316-2.547-1.453-.01.02-2.598-1.5a1 1 0 01-.5-.825.996.996 0 01.13-.544l.001-.001.99-1.73a1.26 1.26 0 01.081-.12l2.432-4.209A1 1 0 0120 27zm13.633 3.438l1.732 1a1 1 0 01.366 1.366l-5 8.66a1 1 0 01-1.366.366l-1.732-1a1 1 0 01-.366-1.366l5-8.66a1 1 0 011.366-.366z"/></svg>
</template>
<script>

export default {
  name: 'IconStorm',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
